export const time = (value) => {
    if (!value)
        return undefined;
    const parsed = new Date(value).getTime();
    return Number.isNaN(parsed) ? undefined : parsed;
};
export const pendingNextRunAt = ({ nextRunAt, subtopicsUpdatedAt, lastRunAt, templateActive, autoReportEnabled, }) => {
    const savedAt = time(subtopicsUpdatedAt);
    if (!nextRunAt || savedAt === undefined)
        return undefined;
    if (templateActive !== true || autoReportEnabled !== true)
        return undefined;
    const ranAt = time(lastRunAt);
    if (ranAt !== undefined && savedAt <= ranAt)
        return undefined;
    return nextRunAt;
};
